module.exports = __webpack_public_path__ + "img/telescope-overlay.87af0621.png";